/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

// import { FieldNamesMarkedBoolean } from 'react-hook-form'
import { SeedMix } from "../types/SeedOrderFormType";

type FieldNamesMarkedBoolean<T> = T;

export const getAllProductIds = (mixes: SeedMix[]) => {
  return mixes?.reduce((acc, mix) => {
    mix?.products?.forEach((seed) => {
      acc?.push(seed.productId);
    });
    return acc;
  }, [] as number[]);
};

export type ProductChangedIndex = {
  mixIndex: number;
  productIndex: number;
};

export const changedQuantity = (mixes: Partial<Readonly<FieldNamesMarkedBoolean<SeedMix[]>>>) => {
  const hasChanged: ProductChangedIndex[] = [];
  mixes?.forEach((mix, mixIndex) => {
    mix?.products?.forEach((product, productIndex) => {
      if (product.quantity) {
        hasChanged.push({ mixIndex, productIndex });
      }
    });
  });

  return hasChanged;
};

export const changedSowingRate = (mixes: Partial<Readonly<FieldNamesMarkedBoolean<SeedMix[]>>>) => {
  const hasChanged: ProductChangedIndex[] = [];
  mixes?.forEach((mix, mixIndex) => {
    mix?.products?.forEach((product, productIndex) => {
      if (product.sowingRate) {
        hasChanged.push({ mixIndex, productIndex });
      }
    });
  });

  return hasChanged;
};

export type PaddockChangedIndex = {
  mixIndex: number;
};

export const changedHectares = (mixes: Partial<Readonly<FieldNamesMarkedBoolean<SeedMix[]>>>) => {
  const hasChanged: PaddockChangedIndex[] = [];
  mixes?.forEach((mix, mixIndex) => {
    mix?.paddocks?.forEach((paddock) => {
      if (paddock.hectares) {
        hasChanged.push({ mixIndex });
      }
    });
  });

  return hasChanged;
};

export const changedFulfillment = (
  mixes: Partial<Readonly<FieldNamesMarkedBoolean<SeedMix[]>>>
) => {
  let hasChanged = false;
  mixes?.forEach((mix) => {
    if (mix?.storeId) {
      hasChanged = true;
    }
    if (mix?.deliveryAddress) {
      hasChanged = true;
    }
  });

  return hasChanged;
};
